import React from 'react';
import { Box, Tabs, TabList, TabPanels, Tab, TabPanel } from '@chakra-ui/react';
import { useSearchParams } from 'react-router-dom';
import LabManagementCompact from './LabManagementCompact';
import AdminUploadManager from './AdminUploadManager';

// Labs page with two tabs: the lab list/management and the test "Directories"
// uploader (moved here from the top admin nav). Tab is reflected in the URL
// (?tab=directories) so it's deep-linkable.
export default function LabsPage() {
  const [params, setParams] = useSearchParams();
  const index = params.get('tab') === 'directories' ? 1 : 0;

  const onChange = (i) => {
    const next = new URLSearchParams(params);
    if (i === 1) next.set('tab', 'directories');
    else next.delete('tab');
    setParams(next, { replace: true });
  };

  return (
    <Box>
      <Tabs index={index} onChange={onChange} colorScheme="blue" isLazy>
        <TabList>
          <Tab>Labs</Tab>
          <Tab>Directories</Tab>
        </TabList>
        <TabPanels>
          <TabPanel px={0}>
            <LabManagementCompact />
          </TabPanel>
          <TabPanel px={0}>
            <AdminUploadManager />
          </TabPanel>
        </TabPanels>
      </Tabs>
    </Box>
  );
}
